import { render, staticRenderFns } from "./BillingTopUp.vue?vue&type=template&id=6cfd948e&scoped=true"
import script from "./BillingTopUp.vue?vue&type=script&lang=ts"
export * from "./BillingTopUp.vue?vue&type=script&lang=ts"
import style0 from "./BillingTopUp.vue?vue&type=style&index=0&id=6cfd948e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd948e",
  null
  
)

export default component.exports